<div class="options-list user-select-none" *ngIf="displaySecurityList">
    <div class="options-list-item">
        <div class="options-list-item-header">
            <div class="options-list-item-title">
                {{ displaySecurityList }}
            </div>
            <div class="options-list-item-controls">
                <a class="btn btn-xs btn-circle btn-transparent btn-close" (click)="removeSecuritylist()"
                ycnTooltip tooltipTitle="Remove" tooltipPlacement="bottom">
                     <span>
                         <svg ycnIcon name="icon-close"></svg>
                     </span>
                </a>
            </div>
        </div>
        <div class="options-list-item-body"
             *ngIf="securitylistSecurityIds.length > 0">
            <div class="form-row form-inline">
                <div class="btn-group" tabindex="0">
                    <a class="btn btn-secondary arrow-left" (click)="prevHandler()"></a>
                    <div class="form-control">{{displaySecurityId}}</div>
                    <a class="btn btn-secondary arrow-right" (click)="nextHandler()"></a>
                </div>
                <div class="form-label">
                    <span class="text-primary">{{ selectedIndex + 1 }}</span> of
                    {{ securitylistSecurityIds.length }} Securities
                </div>
            </div>
            <div class="form-direction">Browse with RIGHT + LEFT keys</div>
        </div>
    </div>
</div>
